exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-info[data-v-59848e06]{margin-bottom:16px}.detail-info>p[data-v-59848e06]{margin:0 0 4px;font-size:13px;color:#606266}.action-bar[data-v-59848e06]{margin-bottom:12px}.text-danger[data-v-59848e06]{color:#f56c6c}.pagination[data-v-59848e06]{margin-top:12px;text-align:right}", ""]);

// exports
